module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1z",
    attrs: {
      "id": "praise"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/frontmatter#praise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for Grace for the Afflicted")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart01"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/part01"
    }
  }, [_c('strong', [_vm._v("Part I"), _c('br'), _vm._v("\n  A SPIRITUAL PERSPECTIVE")])])])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-1",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart01chapter01"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/part01chapter01"
    }
  }, [_vm._v("Chapter 1")])])])]), _vm._v(" "), _c('td', {
    staticClass: "sgc-2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/part01chapter01"
    }
  }, [_vm._v("Fearfully and Wonderfully Made")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart01chapter02"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/part01chapter02"
    }
  }, [_vm._v("Chapter 2")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/part01chapter02"
    }
  }, [_vm._v("The Adversary")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part II"), _c('br'), _vm._v("\n  PSYCHOLOGY, PSYCHIATRY, AND FAITH")])])])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-1",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart02chapter03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part02chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])])])]), _vm._v(" "), _c('td', {
    staticClass: "sgc-2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part02chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Secular and the Sacred")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart02chapter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part02chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part02chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Cake of Figs")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part III"), _c('br'), _vm._v("\n  WHAT ARE MENTAL DISORDERS?")])])])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-1",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart03chapter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])])])]), _vm._v(" "), _c('td', {
    staticClass: "sgc-2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mood Disorders")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart03chapter06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anxiety Disorders")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart03chapter07"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Schizophrenia")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart03chapter08"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dissociative Disorders")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart03chapter09"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eating Disorders")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart03chapter10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Attention-Deficit / Hyperactivity Disorder")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart03chapter11"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Substance Use Disorders")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart03chapter12"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part03chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Borderline Personality Disorder")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rpart04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part IV"), _c('br'), _vm._v("\n  HOW CAN WE HELP THOSE WHO STRUGGLE?")])])])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-1",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rpart04chapter13"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part04chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])])])]), _vm._v(" "), _c('td', {
    staticClass: "sgc-2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part04chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Come to Me")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rpart04chapter14"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part04chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/part04chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Little Things Matter")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rappendix"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', [_c('span', {
    attrs: {
      "href": "#/Text/appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Appendix"), _c('br'), _vm._v("\n  MENTAL HEALTH RESOURCES")])])])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-1",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rappendix01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1")])])])]), _vm._v(" "), _c('td', {
    staticClass: "sgc-2",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("National Mental Health Organizations")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rappendix02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/appendix02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/appendix02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christian Mental Health Counselors, Psychologists, and Physicians")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rappendix03"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/appendix03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 3")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/appendix03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christian Mental Health Support Groups, Clinics, and Hospitals")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rappendix04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/appendix04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 4")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/appendix04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lay Counselor Training Resources")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry2",
    attrs: {
      "id": "rappendix05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/appendix05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 5")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/appendix05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recommended Reading")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    attrs: {
      "id": "rata"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "bm"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/backmattera#bm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also Available")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0